import React from "react";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { faqs } from "../../data/data";
import "./Faqs.scss";

const Faqs = ({ title = "Pricing FAQs" }) => {
  const expandIcon = ({ isActive }) => (
    <div className="faq__icon">
      <DownOutlined className={`manrope down-icon ${isActive ?  `active`: ``}`} rotate={isActive ? 180 : 0} />
    </div>
  );

  return (
    <section id="faqs" className="faq">
      <div className="faq__container">
        <div className="faq__title manrope f-30 w-600 lh-58 black-085">{title}</div>
        <Collapse
          expandIconPosition="right"
          className="faq__list"
          bordered={false}
          expandIcon={expandIcon}
        >
          {faqs.map((item, index) => (
            <Collapse.Panel
              key={index}
              header={<span className="manrope f-16 lh-24 w-700 text-left w-100 black-085">{item.question}</span>}
              className="faq__item"
            >
              <div className="faq__answer manrope f-14 lh-22 w-600 black-085">{item.answer}</div>
            </Collapse.Panel>
          ))}
        </Collapse>
      </div>
    </section>
  );
};

export default Faqs;
